import {DefaultContext} from '../../utils/types';
import React from 'react';
import {State} from '../types/deliveryDetails';

export const initialState: State = {
  deliveryImages: [],
  barcodes: [],
  deliveryNote: '',
  idCaptureDetails: undefined,
  signatureImage: '',
};

const defaultVal: DefaultContext<State> = {
  state: initialState,
  dispatch: null,
};

export const DeliveryDetailsContext = React.createContext(defaultVal);
